// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"6985e2c4","778":"e243a8fa","831":"7705d349","877":"ca665e90","939":"63cdda1d","986":"27f86e3c"}[chunkId] + ".chunk.js";
};